/**
 * 訊息裡的物件名稱截斷（後台訊息通知統一規範 §6-2）。
 *
 * 規範：留在原頁的成功訊息用「已 X『名稱』」，名稱全形 14 字內完整顯示，
 * 超過取前 14 字加 `…`，且**不在半個全形詞中間切**。
 *
 * ## 為什麼要有這個檔
 *
 * 2026-09-03 的共用檔盤點發現，同一條規範被獨立實作了 4 份：
 *   components/cms/CmsListPage.tsx        truncateLabel()   Array.from ✓
 *   backend-administration/…/page.tsx     truncateLabel()   Array.from ✓
 *   lib/trainingVideo/api.ts              messageName()     Array.from ✓
 *   web-management/faq/FaqSectionsEditor  truncate()        String.slice ✗
 *
 * 最後一份用 `String.slice`，那是以 UTF-16 code unit 計數的。實測：
 *
 *   "測".repeat(13) + "🎬新片"
 *     slice(0, 14)  →  "測"×13 + "\ud83c"   ← 孤兒 high surrogate，畫面上是 �
 *     Array.from    →  "測"×13 + "🎬"
 *
 * 三份寫了註解說明為什麼要用 `Array.from`，一份沒有——而且沒有人會發現，
 * 因為要在第 14 個字元剛好落在代理對上才看得到。**規範邏輯散成四份的代價
 * 就是這個：修好三份不等於修好。** 所以收斂成單一實作並用測試釘住。
 *
 * ⚠️ 這裡的「字」＝ Unicode 碼位，不是視覺寬度。ZWJ 組合的 emoji（👩‍👩‍👧）
 * 會被算成多個碼位、也可能被拆開。要做到視覺正確得用 `Intl.Segmenter`
 * 的 grapheme 切分——目前後台的名稱欄位是人名／課程名／設定鍵，
 * 不會出現組合 emoji，故不引入那個成本。真的需要時再換，介面不必改。
 */

/** 規範 §6-2 明定的字數上限。改這個數字等於改規範，不要在呼叫端各自傳參數覆寫。 */
export const MESSAGE_NAME_MAX_CHARS = 14;

export function messageName(name: string | null | undefined): string {
  const text = (name ?? "").trim();
  const chars = Array.from(text);
  return chars.length > MESSAGE_NAME_MAX_CHARS
    ? `${chars.slice(0, MESSAGE_NAME_MAX_CHARS).join("")}…`
    : text;
}
